<div class="auth-page" role="main" aria-label="Change password page">
     <div class="auth-card-wrapper">
            <div class="auth-card change-password-card">
                <div class="auth-form-wrapper form-section">
                    <h3 [appTranslate]="'RESET_PASSWORD'"></h3>

                    <div class="form-group">
                        <label for="change-password-email" [appTranslate]="'EMAIL'"></label>
                        <input id="change-password-email" type="email" class="form-control" name="email" [(ngModel)]="model.Email"
                            aria-describedby="change-password-email-errors">
                        <div id="change-password-email-errors" class="errors error-messages">
                            <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="change-password-old" [appTranslate]="'OLD_PASSWORD'"></label>
                        <input id="change-password-old" type="password" class="form-control" name="oldPassword" [(ngModel)]="model.OldPassword"
                            aria-describedby="change-password-old-errors">
                        <div id="change-password-old-errors" class="errors error-messages">
                            <app-error [errors]="errors" [ErrorKey]="'OldPassword'" class="error-feedback"></app-error>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="change-password-new" [appTranslate]="'NEW_PASSWORD'"></label>
                        <input id="change-password-new" type="password" class="form-control" name="newPassword" [(ngModel)]="model.NewPassword"
                            aria-describedby="change-password-new-errors">
                        <div id="change-password-new-errors" class="errors error-messages">
                            <app-error [errors]="errors" [ErrorKey]="'NewPassword'" class="error-feedback"></app-error>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="change-password-confirm" [appTranslate]="'CONFIRM_PASSWORD'"></label>
                        <input id="change-password-confirm" type="password" class="form-control" name="confirmPassword"
                            [(ngModel)]="model.ConfirmPassword" aria-describedby="change-password-confirm-errors">
                        <div id="change-password-confirm-errors" class="errors error-messages">
                            <app-error [errors]="errors" [ErrorKey]="'ConfirmPassword'" class="error-feedback"></app-error>
                        </div>
                    </div>

                    <div class="loginBtn" *ngIf="!successfulReg">
                        <button type="button" class="btn-primary" (click)="changePassword()"><span
                                [appTranslate]="'CONFIRM'"></span>
                        </button>
                    </div>

                    <div class="errors error-messages errorReason">
                        <app-error [errors]="errors" [ErrorKey]="''" class="mainErrorReason"></app-error>
                    </div>

                    <div *ngIf="successfulReg" class="success-message">
                        <span [appTranslate]="'CHANGE_PASS_SUCCESS'"></span>
                        <button type="button" (click)="redirect()" [appTranslate]="'TO_LOGIN'" aria-label="Go to login"></button>
                    </div>
                </div>
            </div>
        </div>
</div>